var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConvertible(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17065",
    fill: "none",
    stroke: "#304393",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12664",
    d: "M13.056 2.937a1.126 1.126 0 11-1.593 0 1.124 1.124 0 011.593 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12665",
    d: "M2.954 13.063a1.126 1.126 0 111.593 0 1.124 1.124 0 01-1.593 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12666",
    d: "M4.628 12.966a6.032 6.032 0 009.293-6.024"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12667",
    d: "M2.089 9.059a6.013 6.013 0 019.293-6.024"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12668",
    d: "M8 10.501s2-.959 2-2.4V6.453l-1.459-.525a1.6 1.6 0 00-1.084 0L6 6.453v1.649c0 1.439 2 2.399 2 2.399z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12669",
    d: "M0 0h16v16H0z",
    fill: "none"
  })));
}
export default SvgConvertible;


//////////////////
// WEBPACK FOOTER
// ./src/icons/convertible.svg
// module id = 753
// module chunks = 13